import React, { useState } from 'react';

import { Button } from '@sopranodesign/pulse-components';

import CreateTicketModal from './CreateTicketModal';

const CreateTicketButton = ({ children }) => {
  const [create, setCreate] = useState(false);

  const handleStartCreating = () => setCreate(true);

  const handleStopCreating = () => setCreate(false);

  return (
    <>
      {create && <CreateTicketModal handleClose={handleStopCreating} />}
      <Button onClick={handleStartCreating} variant="primary" icon="plus">
        {children}
      </Button>
    </>
  );
};

export default CreateTicketButton;
